import useSWR from 'swr'

const fetcher = (url: string) => fetch(url).then((res) => res.text())

export default () => {
	return useSWR(import.meta.env.VITE_ALMA_FOOTER, fetcher)
}
